import { IConfig } from '@cian/config/shared';
import { REGIONS_WITHOUT_COM } from '../../constants/regionsWithoutCom';

export const getRegionWithoutCom = (config: IConfig, slug: string): boolean => {
  const regions = config.get<string[]>('info-agency-rating-frontend.regionWithOutCom') || REGIONS_WITHOUT_COM;

  return regions.some(elem => elem === slug);
};
